import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/StormcloudButton.module.scss'

import { Button } from 'react-bootstrap'

class StormcloudButton extends React.Component {

  render() {

    const { text, width, svg, action, type, className } = this.props,
    style = {}

    if(width != 170) style.width = width + `px`

    return (
      <Button
        className={className != `` ? `${className} ${styles.button}` : styles.button}
        as={`div`}
        variant='secondary'
        style={style}
        onClick={() => action()}
      >
        <div className={styles.button_icon}>{svg}</div>
        <div className={styles.button_text}>{text}</div>
      </Button>
    )
  }
}

StormcloudButton.propTypes = {
  text: PropTypes.string,
  width: PropTypes.number,
  svg: PropTypes.object,
  action: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string
}

StormcloudButton.defaultProps = {
  text: `Отправить`,
  width: 170,
  svg: (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
    </svg>
  ),
  action: () => {
    window.console.log( `btn click` )
  },
  type: `button`,
  className: ``
}

export default StormcloudButton